import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
`;

export const ContactBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  max-width: 1128px;
  margin: auto;
  padding: 0px 0 30px;

  align-items: center;
  @media (max-width: 768px) {
    margin: 10px 10px;
    flex-direction: column;
    padding: 30px 0 10px;
  }
  @media (max-width: 1100px) {
    margin: 0px 30px;
  }
`;

export const ContactText = styled.a`
  color: var(--secondary);
  padding-top: 30px;
  text-decoration: none;

  :hover {
    color: var(--primary);
  }
`;

export const MadeText = styled.h2`
  padding-top: 30px;
  color: var(--secondary);
  font-weight: bold;
`;
